export enum AppType {
  twentyfourme = 'twentyfourme',
  groupcal = 'groupcal'
}

export function is24meApp(): boolean {
  const tfm = process.env.REACT_APP_APP_TYPE === AppType.twentyfourme
  return tfm
}

export function isGroupcalApp(): boolean {
  return process.env.REACT_APP_APP_TYPE === AppType.groupcal
}
